import { ValidationInputType } from "@cak-legacy/generation-core";
import { FileAbstractValidation } from "./FileAbstractValidation";
import { CustomErrorMessage } from "./ValidationHelper";
import { translate } from "../Locales/translator";

export class HasFileMaxSizeValidation extends FileAbstractValidation {
  key = "hasFileMaxSize";
  constructor(
    private readonly maxSizeInMB: number,
    customErrorMessage?: CustomErrorMessage,
    private readonly customFileErrorMessage?: CustomErrorMessage
  ) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    const uploadedFilesBiggerThenMaxSize = this.getFiles(value).some((file) => !this.isValidFile(file));
    return !uploadedFilesBiggerThenMaxSize;
  };

  isValidFile = (file: File) => {
    return file.size <= this.maxSizeInMB * 1024 * 1024;
  };

  defaultMessage = (_label: string): string =>
    translate("Generation_Form_{label}MagNietGroterZijnDan{maxSizeInMB}", { label: _label, maxSizeInMB: this.maxSizeInMB.toString() });

  fileErrorMessage = (fileLabel: string): string =>
    this.customFileErrorMessage
      ? this.customFileErrorMessage(fileLabel)
      : translate("Generation_Form_{fileLabel}MagNietGroterZijnDan{maxSizeInMB}", { fileLabel: fileLabel, maxSizeInMB: this.maxSizeInMB.toString() });
}
